<template>
  <section>
    <qx-custom-form
      @sub="sub"
      :noSubBtn="true"
      ref="baseForm"
      :formData="formData"
    />
  </section>
</template>

<script>
export default {
  props: {
    invoice: {
      default: '',
    },
    amount: {
      default: '',
    },
  },
  data () {
    return {
      formData: {
        form: [
          {
            label: '发票号',
            value: 'invoice',
            type: 'input',
            default: this.invoice,
            placeholder: '请输入发票号',
          },
          {
            label: '发票金额',
            value: 'amount',
            type: 'input',
            default: this.amount,
            placeholder: '请输入发票金额',
          },
        ],
        rules: { // 表单验证规则
          invoice: [ // 发票号
            { required: true, message: '请输入发票号', trigger: 'blur' },
          ],
          amount: [ // 发票金额
            { required: true, message: '请输入发票金额', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {
    async sub () {
      const formData = await this.$refs.baseForm.sub();
      return formData;
    },
  },
};
</script>

<style>

</style>
